<template>
  <a-modal
    title="未开始学习"
    :width="900"
    centered
    :visible="visible"
    @cancel="handleCancel"
    :footer="null"
  >
    <div class="table-absentees-wrapper">
      <a-table
        row-key="id"
        :scroll="scroll"
        :loading="tableLoading"
        :columns="columns"
        :data-source="studentList"
        :pagination="false"
      />
      <div class="pagination">
        <a-pagination
          v-show="pagination.total > 0"
          v-model="pagination.current"
          :total="pagination.total"
          :page-size="pagination.pageSize"
          @change="handleChangePageNum"
        />
      </div>
    </div>
  </a-modal>
</template>

<script>
const columns = [
  {
    title: '学员姓名',
    dataIndex: 'studentName'
  },
  {
    title: '手机号',
    dataIndex: 'phoneNumber'
  },
  {
    title: '讲次信息',
    dataIndex: 'name',
    customRender: (text, row) => `第${row.num}讲  ${row.name}`
  }
]

export default {
  props: {
    groupIds: {
      type: Array,
      default: () => []
    },
    visible: {
      type: Boolean,
      default: true
    },
    list: {
      type: Array,
      default: () => []
    }
  },

  watch: {
    visible(val) {
      if (val) {
        this.pagination.current = 1
        this.getList()
      }
    }
  },

  data() {
    return {
      columns,
      tableLoading: false,
      studentList: [],
      pagination: {
        pageSize: 50,
        total: 0,
        current: 1
      },
      scroll: {}
    }
  },

  mounted() {
    const h = document.documentElement.clientHeight || document.body.clientHeight
    this.scroll.y = parseInt(h - 370)
  },

  methods: {
    getList() {
      this.tableLoading = true
      const searchParams = {
        xkhTeacherCourseIds: this.groupIds,
        pageSize: this.pagination.pageSize,
        pageNum: this.pagination.current
      }
      this.$service.supervision.getAbsenteesStudent(searchParams).then(res => {
        this.tableLoading = false
        this.pagination = {
          ...this.pagination,
          total: res.itemTotal,
          current: res.pageNum
        }
        this.studentList = [...res.list]
      }).catch(err => {
        this.tableLoading = false
      }).finally(() => {
        this.tableLoading = false
      })
    },
    handleCancel() {
      this.$emit('update:visible', false)
    },
    handleChangePageNum(current, pageSize) {
      this.pagination.current = current
      this.pagination.pageSize = pageSize
      this.getList()
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/static/css/base.less';
.table-absentees-wrapper {
    display: flex;
    flex-direction: column;
    position: relative;
    flex: 1;
    overflow: hidden;
    background: @gray-10;
    // 弹窗上下外边距40px
    height: calc(100vh - 53px - 33px - 16px - 40px - 40px);
  }
:deep(.ant-modal-body) {
  padding-bottom: 20px;
}
.pagination {
  text-align: right;
  position:absolute;
  bottom: 24px;
  right: 0;
}
</style>